/**
 * @deprecated
 */
export class CrmStrategiesService {
  constructor(SalesforceFactory, ZendeskFactory) {

    this._all = [SalesforceFactory, ZendeskFactory];
  }

  /**
   * @deprecated
   */
  getStrategy(crmType) {
    return this._all.filter(s => s.getTypeString() === crmType)[0];
  }
  /**
   * @deprecated
   */
  static CrmStrategiesFactory(SalesforceFactory, ZendeskFactory) {
    return new CrmStrategiesService(SalesforceFactory, ZendeskFactory);
  }
}
/**
 * @deprecated
 */
CrmStrategiesService.CrmStrategiesFactory.$inject = ['SalesforceFactory', 'ZendeskFactory'];
